import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "640y4i8g", 
  dataset: "production", 
  useCdn: true
});